import styles from 'widget/event_components/ticket-spot.scss';
import { TicketCheckoutSummaryForm } from 'widget/event_components/Ticket/components/Summary';
import { AccessCode } from '../AccessCode';
import { CartTicket } from 'widget/event_components/Ticket/components/CartTicket';
import { useMemo } from 'react';
import SeatingSelector from 'widget/event_components/Seating';

export const TicketCheckoutForm = ({
  tickets,
  hasAccessCodeControllerTickets,
  event,
  settings,
  onCartUpdate,
  cart = {},
  handleTicketOverride,
  promoCode,
  loadingCheckoutValues,
  checkoutValues,
  handleTicketUpdate,
  handleUpdateTicketsList,
  handleInitTicketStateChange,
  ticketOverrides,
  errors,
  handleWaitlistTicketClick,
  onResizeComponent,
  // Seating props
  hasSeatingChart = false,
  seatingChartLoading = false,
  seatSelections = [],
  onSeatSelection,
  onHoldTokenGenerated,
  // Addon props - passed for summary display only
  selectedAddons,
}) => {
  const isMobile = window.isMobileType;
  const totalTicketsSold = tickets.reduce((sum, ticket) => sum + (ticket.get('quantity_sold', 0) + (cart[ticket.get('id')] || 0)), 0);

  // Filter out seated tickets - they should only be selectable via seating chart
  const nonSeatedTickets = hasSeatingChart ? tickets.filter((ticket) => !ticket.get('isSeated')) : tickets;
  const renderTickets = useMemo(
    () =>
      nonSeatedTickets
        .sort((a, b) => a.get('order', 0) - b.get('order', 0))
        .map((ticket) => (
          <CartTicket
            cart={cart}
            settings={settings}
            event={event}
            ticket={ticket}
            key={ticket.get('id')}
            onCartUpdate={onCartUpdate}
            errors={errors}
            handleTicketOverride={handleTicketOverride}
            isMobile={isMobile}
            loadingCheckoutValues={loadingCheckoutValues}
            promoCode={promoCode}
            totalTicketsSold={totalTicketsSold}
            handleWaitlistTicketClick={handleWaitlistTicketClick}
          />
        )),
    [nonSeatedTickets, cart, settings, event, errors, isMobile, loadingCheckoutValues, promoCode, totalTicketsSold]
  );

  return (
    <div className={styles.ticketsCart}>
      {/* Seating chart section - rendered at the top */}
      {hasSeatingChart && !seatingChartLoading && (
        <div className={styles.seatingChartSection}>
          <SeatingSelector eventId={event.get('id')} cart={[]} onSeatsSelected={onSeatSelection} onHoldTokenGenerated={onHoldTokenGenerated} />
        </div>
      )}

      {/* Access code section */}
      {hasAccessCodeControllerTickets && (
        <AccessCode
          settings={settings}
          event={event}
          cart={cart}
          tickets={tickets}
          handleTicketUpdate={handleTicketUpdate}
          handleUpdateTicketsList={handleUpdateTicketsList}
          handleInitTicketStateChange={handleInitTicketStateChange}
          onResizeComponent={onResizeComponent}
        />
      )}

      {/* Non-seated tickets section - rendered below seating chart */}
      {renderTickets}

      {/* Summary with seats and tickets */}
      <TicketCheckoutSummaryForm
        loadingCheckoutValues={loadingCheckoutValues}
        checkoutValues={checkoutValues}
        tickets={tickets}
        event={event}
        cart={cart}
        settings={settings}
        handleTicketUpdate={handleTicketUpdate}
        handleInitTicketStateChange={handleInitTicketStateChange}
        ticketOverrides={ticketOverrides}
        seatSelections={seatSelections}
        selectedAddons={selectedAddons}
      />
    </div>
  );
};
